/*
The EditCustomer component is used on the new-customer page and
the edit-customer page to change settings for an existing customer.

It is assumed that all the requried data from DataModel has been loaded.

 */
import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AppModel from '../DataModel/AppModel';

import {List, ListItem} from 'material-ui/List';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import Checkbox from 'material-ui/Checkbox';
import Subheader from 'material-ui/Subheader';
import Divider from 'material-ui/Divider';

import SelectSegmentType from './SelectSegmentType';
import SelectCountryCode from './SelectCountryCode';
import SelectLanguageCode from './SelectLanguageCode';
import PageLoading from '../components/PageLoading';


export default
@observer class EditCustomer extends Component {

  // Return as utility method that updates a fied on a target object:
  updateField(target) {
    return function(event) {
      var field = event.target.dataset.propname;
      var value = event.target.value;
      target[field]=value;
    }
  }


  handleCheckboxToggle(field) {
    return function() {
      AppModel.updateUserForm.user[field]=!AppModel.updateUserForm.user[field];
    }
  }

  // If clicked, we toggle the setting for a given job type.
  toggleJobType(customer, jobType) {
    return function() {
      customer.toggleJobType(jobType);
    }
  }

  render() {
    let form = this.props.form;
    let customer = form.customer;

    return  <PageLoading loading={ AppModel.fetchingCustomerDetails
            || AppModel.customerListLoading
            || AppModel.fetchingAvailableJobTypes
            || AppModel.fetchingLocationTypes
            || AppModel.fetchingSupportedCountries
            || AppModel.fetchingSupportedLanguages
            || AppModel.fetching_customer_segments
          }>
      <List style={{paddingTop:'0px'}}>
      <TextField data-propname="name"
                floatingLabelText={uiMsg('CE_CUSTOMER_NAME',"Customer name (Required)")}
                hintText={uiMsg('CE_CUSTOMER_NAME_HINT',"Name of customer")}
                value={customer.name || ""}
                onChange={this.updateField(customer)}
                fullWidth={true}
      />
      {AppModel.isSystemAdmin ? 
      <TextField data-propname="id_account"
                floatingLabelText={uiMsg('CE_ACCOUNT_ID',"Decon-X Account Id")}
                hintText={uiMsg('CE_ACCOUNT_ID_HINT',"Account Id")}
                value={customer.id_account || ""}
                onChange={this.updateField(customer)}
                fullWidth={true}
      /> : null }
      <SelectSegmentType customer={customer} />
      <SelectCountryCode target={customer}   />
      <SelectLanguageCode target={customer}  />
      <TextField data-propname="additional_sms_recipients"
              floatingLabelText={uiMsg('CE_ADDN_SMS_RECIPIENT',"Additional SMS Recipient ( International format including country code )")}
              hintText={uiMsg('CE_ADDN_SMS_RECIPIENT_HINT',"Any additional recipient that requires SMS notification for jobs etc")}
              value={customer.additional_sms_recipients || ""}
              onChange={this.updateField(customer)}
              fullWidth={true}
      />
      {AppModel.isSystemAdmin ? 
      <List>
        <Subheader style={{position:'relative',left:'-16px'}}>
          {uiMsg('CE_CUSTOMER_IS_DISTRIBUTOR',"Customer is distributor")}</Subheader>        
          <ListItem
            leftCheckbox={
              <Checkbox checked={!!customer.is_distributor}
                        data-propname="is_distributor"
                        onCheck={
                          ()=>{customer.is_distributor=!customer.is_distributor}
                        }
              />
            }
            primaryText={uiMsg('CE_IS_DISTRIBUTOR_CHECKTEXT',"Can create and administrate own customers")}
          />
      </List> : null }

      <List>
        <Subheader style={{position:'relative',left:'-16px'}}>
          {uiMsg('CE_JOB_TYPES_AVAIL',"Job types available to customer")}</Subheader>
          {AppModel.job_types.map( jt =>
          <ListItem
            key={jt.id}
            leftCheckbox={
              <Checkbox checked={customer.hasJobType(jt)}
                        onCheck={this.toggleJobType(customer,jt)} />}
            primaryText={<span>{jt.name} {
              customer.hasJobType(jt) ?
              <span>(Priority={customer.getJobType(jt).priority})</span>
              : null }
              </span>}
          />)}
      </List>
    </List>
    </PageLoading>
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/EditCustomer.jsx
 **/